import React from "react";
import { createRoot } from "react-dom/client";

import { createTheme, ThemeProvider } from "@mui/material/styles";
import "./style.css";
import App from "./App";

const theme = createTheme({
  palette: {
    primary: {
      light: "#ff8f33",
      main: "#f06a00",
      dark: "#b35000",
      contrastText: "#fff",
    },
    secondary: {
      light: "#009eb3",
      main: "#006674",
      dark: "#002d33",
      contrastText: "#fff",
    },
    mode: "light",
  },
  typography: {
    fontFamily: '"Raleway", sans-serif',
  },
  components: {
    MuiTypography: {
      styleOverrides: {
        gutterBottom: {
          marginBottom: 20,
        },
      },
    },
  },
});

createRoot(document.getElementById("root")!).render(
  <ThemeProvider theme={theme}>
    <App />
  </ThemeProvider>,
);
